import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { PROMOTION_CAMPAIGN_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updatePromotionCampaignStatusAction = createAsyncThunk(
    'price/updatePromotionCampaignStatusAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ PROMOTION_CAMPAIGN_PATH }/${ data.id }/status?status=${ data.status }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updatePromotionCampaignStatusSlice = createSlice({
    name: 'updatePromotionCampaignStatusSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updatePromotionCampaignStatusAction.pending, () => STATE__API__STARTED);
        builder.addCase(updatePromotionCampaignStatusAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updatePromotionCampaignStatusAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updatePromotionCampaignStatusState = (state) => state.price.updatePromotionCampaignStatus;
export default updatePromotionCampaignStatusSlice.reducer;
